import logo from './images/perkleaflogo.png'
import { Navbar, Nav, Container } from 'react-bootstrap';
import './nav.css'

const NavigationBar = () => {
  return (
    <Container fluid >
    <div style={{overflow:'hidden'}} id='mainLogo' className="text-center" >
            <img style={{width:"80%",height:"80%",overflow:"hidden"}} src={logo}/>
          </div>
    <Navbar variant="dark" id="navbar">
  <Container fluid className="justify-content-center">
    <Navbar.Collapse id="navbar-nav" className="justify-content-center">
      <Nav className="text-center">
        <Nav.Link id="navi" href="/" className="mx-4 text-centre">Home</Nav.Link>
        <Nav.Link id="navi" href="product" className="mx-2">Products</Nav.Link>
        <Nav.Link id="navi" href="contact" className="mx-2">Contacts</Nav.Link>
      </Nav>
    </Navbar.Collapse>
  </Container>
</Navbar>
    </Container>
  );
};

export default NavigationBar;
